module.exports = __webpack_public_path__ + "static/img/spin_wheel.5c6bfc7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/spin_wheel.png
// module id = wLtv
// module chunks = 1